import {BASE_URL} from './Configuration/config';
import { getCurrentSession } from '../Apis/getCurrectUserToken';
import axios from "axios";  



const request = async ({ url, method, data = {} }) => {
let header = await getCurrentSession();
  const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: header
  });

  try {
    let response = await axiosInstance.request({
      url,
      method,
      data
    });
  
  
    if (response && response.data) {
        return response.data;
    }  
  } catch(e) {

    if (e && e.response && e.response.data && e.response.data.errorCode == "403") {
      alert("You are not authorized to access this screen.");
      window.location.assign("#/Dashboard");
      window.location.reload();
    }
  }
  return null
}

export default request;